import { render, staticRenderFns } from "./RandomModal.vue?vue&type=template&id=226dba90&scoped=true&"
import script from "./RandomModal.vue?vue&type=script&lang=js&"
export * from "./RandomModal.vue?vue&type=script&lang=js&"
import style0 from "./RandomModal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./RandomModal.vue?vue&type=style&index=1&id=226dba90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226dba90",
  null
  
)

export default component.exports